module.exports = __webpack_public_path__ + "assets/img/banner-estudio-1920.jpg.bak.jpg";